module.exports = __webpack_public_path__ + "static/media/group.b1a4c58c.svg";